import { AxiosResponse } from 'axios';

export const createUnauthorizedListener =
  (onUnauthorized: Function) => (res: AxiosResponse) => {
    if (res.status === 401) {
      onUnauthorized();
    }
    return res;
  };
